<template>
  <div class="t_home">
   <img src="../assets/img/logo.png" style="width: 58px;" alt="">
   <div style="font-size: 20px;margin-top: 10px;">激活助手</div>
   <div style="font-size: 12px;">菜鸟号卡业务激活终端</div>
   <a :href="anlink"  style="background-color: #17C311;margin-top: 250px;" class="t_down_btn">
    <img  src="../assets/img/an.png" alt="">
    安卓手机下载
   </a>
   <a :href="pinglink"  style="background-color: #2687FF;margin-top: 20px;" class="t_down_btn">
    <img  src="../assets/img/ping.png" alt="">
    苹果手机下载
   </a>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {url,login,getdoown} from '@/assets/js/common.js'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  data() {
    return{
      anlink:'',
      pinglink:'' 
    }
  },
  mounted(){

    console.log(this.$route.query.type)

    getdoown({'category_id':'26','type':'1'}).then((response)=>{
          console.log(response)
          this.anlink = response.data.data.uri
      })
      getdoown({'category_id':'26','type':'2'}).then((response)=>{
          console.log(response)
          this.pinglink = response.data.data.uri
      })
    
    // if(this.$route.query.type=='dev'){
    //   getdoowndev({'category_id':'1','type':'1'}).then((response)=>{
    //       console.log(response)
    //       this.anlink = response.data.data.uri
    //   })
    //   getdoowndev({'category_id':'1','type':'2'}).then((response)=>{
    //       console.log(response)
    //       this.pinglink = response.data.data.uri
    //   })
    // }else{
    //   getdoown({'category_id':'1','type':'1'}).then((response)=>{
    //       console.log(response)
    //       this.anlink = response.data.data.uri
    //   })
    //   getdoown({'category_id':'1','type':'2'}).then((response)=>{
    //       console.log(response)
    //       this.pinglink = response.data.data.uri
    //   })
    // }
    
    
  },
  methods:{
    // login(){
    //   login({'type':'111'}).then((response)=>{
    //     console.log(response)
    //   })
    // },?category_id=1&type=1
    // getdownload(){
      
    // }
  }
}
</script>
<style scoped>
.t_home{
  width: 100vw;
  height: 100vh;
  background:black;
  display: flex;
  flex-direction: column;
  color: white;
  align-items: center;
  justify-content: center;
}
.t_down_btn{
  display: flex;
  justify-content: center;
  width:80vw;
  height: 60px;
  align-items: center;
  border-radius: 50px;
  color: white;
  text-decoration: none;
}
.t_down_btn img{
  display: block;
  margin-right: 10px;
  width: 22px;
}
</style>